import React from "react";
import {shallowEqual, useSelector} from "react-redux";
import {selectEntityForOrgTree} from "../../../../state/slices/OrgTree";
import {Typography} from "@material-ui/core";
import {capitalizeFirstLetter} from "./BreadCrumbTitle";

export const SubSectionTitle = ({entityID, title}) => {
    const parentEntityName = useSelector((state) => {
        const parentEntityId = selectEntityForOrgTree(entityID)(state)?.parentEntityID;
        if (!parentEntityId) return null;
        return selectEntityForOrgTree(parentEntityId)(state)?.name;
    }, shallowEqual);

    return (
        <>
            <Typography
                variant="h6"
                color="textSecondary"
            >
                {capitalizeFirstLetter(parentEntityName)} / {capitalizeFirstLetter(title)}
            </Typography>
        </>
    );
};